import { useContext } from "react";

import {
  CatalogPageContext,
  CatalogPageContextData,
} from "shared/catalog/CatalogPageContext/index";

export const useCatalogPageContext = <
  T extends NonNullable<CatalogPageContextData>,
>() => {
  const catalogPageContext = useContext(CatalogPageContext);

  if (catalogPageContext === undefined) {
    throw new Error(
      "useCatalogPageContext must be used within CatalogPageContextProvider",
    );
  }

  return catalogPageContext as T;
};
